"use client";

import { useQuery } from "@tanstack/react-query";

import type { TelemetryAggregatesParams } from "@/lib/api/endpoints/telemetry";
import { telemetryGateway, telemetryQueryKeys, type TelemetryAggregatesQueryKeyParams } from "@/modules/telemetry/api";

export function useTelemetryAggregates(
  params: TelemetryAggregatesParams & { metricsKey: string },
  enabled: boolean,
) {
  const { metricsKey, ...apiParams } = params;
  const key: TelemetryAggregatesQueryKeyParams = {
    ...apiParams,
    metricsKey,
  };

  return useQuery({
    queryKey: telemetryQueryKeys.aggregates(key),
    queryFn: () => telemetryGateway.fetchAggregates(apiParams),
    enabled,
    staleTime: 20_000,
  });
}
